var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeartWithBlobinline = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 38,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#HeartWithBlob_inline_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.782 21.236c2.667-5.333.72-14.222-3.324-18.267C32.134-.328 24.036-.115 19.725.125 14.249.427 8.685 2.24 4.755 6.063.828 9.885-1.145 15.938.704 21.103c2.666 7.35 9.04 17.04 16.773 15.91 7.333-1.075 14.222-8.666 18.542-12.444a12.499 12.499 0 0 0 2.764-3.333Z",
  fill: "#DFEDF7",
  style: {
    mixBlendMode: "multiply"
  },
  opacity: 0.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.328 8.843C15.347 4.937 8 7.556 8 13.71v.714c0 1.782.618 3.509 1.75 4.885L20 31l10.25-11.692A7.696 7.696 0 0 0 32 14.423v-.714c0-6.153-7.347-8.772-11.328-4.866A6.88 6.88 0 0 0 20 9.61a6.88 6.88 0 0 0-.672-.766Zm10.16 9.819A6.697 6.697 0 0 0 31 14.423v-.714c0-5.534-7.01-7.722-10.202-3.497L20 11.268l-.798-1.056C16.01 5.987 9 8.175 9 13.709v.714c0 1.545.534 3.043 1.512 4.239L20 29.483l9.488-10.821Z",
  fill: "#51585B"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "HeartWithBlob_inline_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h40v37.102H0z"
})))));
export default SvgHeartWithBlobinline;